import Vue from 'vue'

export default {
  checkEmail: function (email) {
    let apiDetailPath = '/users/find?email=' + encodeURIComponent(email)
    return Vue.http.get(Vue.env.apiPath + apiDetailPath)
  },
  pingCloud: function () {
    let apiDetailPath = '/users/find?email=ping'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath)
  },
  getMyProfile: function () {
    let apiDetailPath = '/users/me'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  updateMyEmailAsVerified: function () {
    let apiDetailPath = '/users/me'
    let data = {
      is_verify: 1
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  updateMyProfile: function ({firstName, lastName}) {
    let apiDetailPath = '/users/me'
    let data = {
      firstname: firstName,
      lastname: lastName
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  changeMyEmail: function ({email}) {
    let apiDetailPath = '/users/me/change_email_verify'
    let data = {
      email: email
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  changeMyPassword: function ({password}) {
    let apiDetailPath = '/users/me/change_password'
    let data = {
      password: password
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getMyAvatarUploadUrl: function ({fileExtension}) {
    let apiDetailPath = '/users/me/picture'
    let data = {
      format: fileExtension
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getMyDealer: function (tsSessionDealerId) {
    let apiDetailPath = '/users/me/dealer'
    if (tsSessionDealerId) {
      apiDetailPath += '?dealer_id=' + tsSessionDealerId
    }
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getMyPublicIp: function () {
    let apiDetailPath = '/users/me/ip'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getMyMetadata: function () {
    let apiDetailPath = '/users/me/metadata'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  createMyMetadata: function (metadata) {
    let apiDetailPath = '/users/me/metadata'
    let data = {
      metadata: metadata
    }
    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  updateMyMetadata: function (metadata) {
    let apiDetailPath = '/users/me/metadata'
    let data = {
      metadata: metadata
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  deleteMyMetadata: function () {
    let apiDetailPath = '/users/me/metadata'
    return Vue.http.delete(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  }
}



// WEBPACK FOOTER //
// ./src/apis/user.js